<template>
  <v-snackbar
    v-model="visible"
    tile
    :timeout="-1"
    :multi-line="true"
    id="upload-progress-bar"
    :vertical="true"
  >
    <v-col cols="12" class="py-0">
      <v-row align="center" justify="center" class="mb-2"
        ><span class="text-subtitle-active">Uploading</span></v-row
      >
      <template v-for="file in uploadingTasks">
        <v-row align="center" :key="file.name"
          ><span class="text-body-light">{{ file.name }}</span>
          <v-progress-linear
            :value="file.progress"
            style="width: 100px"
            class="ml-2"
          ></v-progress-linear
        ></v-row>
      </template>
    </v-col>
    <template v-slot:action="{ attrs }">
      <v-btn
        class="button color--inactive"
        small
        text
        v-bind="attrs"
        @click="hideUploader"
      >
        Hide
      </v-btn>
    </template>
  </v-snackbar>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
export default {
  computed: {
    ...mapGetters(['uploadingTasks', 'uploaderHidden']),
    visible() {
      return this.uploadingTasks.length > 0 && !this.uploaderHidden
    },
  },
  methods: {
    ...mapActions(['hideUploader']),
  },
}
</script>

<style lang="sass">
#upload-progress-bar > .v-snack__wrapper
  min-width: 150px
  max-width: 216px
  left: 0
  position: absolute
</style>